import Vue from 'vue';

import { createInertiaApp, Link } from '@inertiajs/inertia-vue'
import { Inertia } from '@inertiajs/inertia'
import { InertiaProgress } from '@inertiajs/progress'
import PortalVue from 'portal-vue';
import VueMeta from "vue-meta";
import VSnackbars from "v-snackbars";
import { VueFrappe } from 'vue2-frappe'

import store from './vuex/store.js'

window.axios = require('axios');

import vuetify from './plugins/vuetify';

Vue.component('InertiaLink', Link)
Vue.use(PortalVue);
Vue.use(VueMeta);

Vue.component('v-snackbars', VSnackbars);
Vue.component('vue-frappe', VueFrappe);

InertiaProgress.init()

Vue.filter("formatDate", function(str){
    if(str !== null){
      str = moment(String(str)).format('DD.MM.YYYY');
    }else{
      str = null;
    }

    return str;
});
Vue.filter("formatTime", str => moment(String(str)).format('HH:mm'));
Vue.filter("fullDate", str => moment(String(str)).format('DD.MM.YYYY. HH:mm'));
Vue.filter('round', function(value, decimals) {
    if(!value) {
      value = 0;
    }

    if(!decimals) {
      decimals = 0;
    }

    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    return value;
  });

  Vue.filter('toHours', mins => {

  var h = mins / 60 | 0,
      m = mins % 60 | 0;

   return moment.utc().hours(h).minutes(m).format("HH:mm");
  })

  Inertia.on('navigate', (event) => {

    if(process.env.NODE_ENV != 'development'){
      gtag('event', 'page_view', {
      'page_location': event.detail.page.url
      });
    }
  })

const app = document.getElementById('app');

var organization_name = JSON.parse(app.dataset.page).props.organization.name

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  setup({ el, app, props }) {
    new Vue({
      vuetify,
      store,
      metaInfo: {
        titleTemplate: title => (title ? `${title} - ${organization_name}` : 'Fitbrry'),
      },
      render: h => h(app, props),
    }).$mount(el)
  },
})
